function requireKey(value: string | undefined, description: string): string {
  if (value) return value
  throw new Error(`Missing ${description}`)
}

/**
 * Public browser/server key. This must be Supabase's opaque publishable key.
 *
 * Keep these process.env references explicit: Next.js only inlines public
 * variables it can see statically at build time.
 */
export function getSupabasePublishableKey(): string {
  return requireKey(
    getOptionalSupabasePublishableKey(),
    "NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY"
  )
}

export function getOptionalSupabasePublishableKey(): string | undefined {
  return resolveSupabasePublishableKey(
    process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY
  )
}

export function resolveSupabasePublishableKey(
  publishableKey: string | undefined
): string | undefined {
  if (!publishableKey) return undefined
  if (!/^sb_publishable_[A-Za-z0-9_-]+$/.test(publishableKey)) {
    throw new Error("NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY must be an opaque sb_publishable_ key")
  }
  return publishableKey
}
